import { PropsWithChildren } from 'react';
import { HubPage } from '../../../../../types';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubPage } from '../../store/features/page';
import Layout, { LayoutProps } from '../Layout';

export default function PageLayout(
  props: Omit<PropsWithChildren<LayoutProps>, 'layout'>,
) {
  const { data: layout } = useRootSelector(selectBrandHubPage<HubPage>());

  return <Layout {...props} layout={layout} />;
}
